module.exports={
	"Scope": "ObservationTag-List",
	"CoreEntity": "ObservationTag",
	"TitleTemplate": "Observation Tags",
	"Descriptors":
	{
		"Tag":
		{
			"Name": "Tag",
			"Hash": "ObsTagListTag",
			"PictDashboard": {}
		},
		"TagType":
		{
			"Name": "Tag Type",
			"Hash": "ObsTagListTagType",
			"PictDashboard": {}
		},
		"Global":
		{
			"Name": "Global",
			"Hash": "ObsTagListGlobal",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.Global~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.Global~}{~HCS:Record.Payload.Global:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.Global:true~}</div>"
			}
		}
	}
}
